import { Map } from 'immutable';

import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';
import PromoCode from '../records/PromoCode';

export class PromoCodeStore extends BaseStore {

    getActive () {
        return this.get('active');
    }

    deserialize (serialized) {
        let state = new Map();

        if (serialized && serialized.active) {
            state = state.set('active', PromoCode.fromJSON(serialized.active));
        }

        return state;
    }

    handleApplied ({ promoCode }) {
        this.setState(this.state.set('active', promoCode));
    }

    handleRemoved () {
        this.setState(this.state.set('active', null));
    }

    getActionHandlers () {
        return {
            [ActionTypes.PROMOCODE_APPLIED]: this.handleApplied,
            [ActionTypes.PROMOCODE_REMOVED]: this.handleRemoved,
            [ActionTypes.ORDER_PAID]: this.handleRemoved,
            [ActionTypes.LOGGED_OUT]: this.handleRemoved
        };
    }
}

const instance = new PromoCodeStore({
    storageKey: 'promoCode',
    expires: 60 * 60 * 3
});

export default instance;



// WEBPACK FOOTER //
// ./src/stores/PromoCodeStore.js